module.exports = __webpack_public_path__ + "img/20180815_154807_243.eb802cc2.jpg";